// TeamItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../common/avatar/avatar.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class TeamItem extends Component {
  static get propTypes () {
    return {
      team: PropTypes.object.isRequired,
      onSelect: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      team: null,
      onSelect: null
    }
  }

  render () {
    const team = this.props.team
    const imageUrl = team.imageUrl
      ? team.imageUrl
      : '/images/common/default_company.png'

    return (
      <div className='team-item' onClick={this.props.onSelect}>
        <div className='teaminfo'>
          <Avatar
            imageUrl={imageUrl}
            title={team.name}
            className='teamavatar'
          />
          <IconButton
            icon='team-next'
            title='common.team.tipNext'
            type='primary'
            size='big'
            canHover={false}
          />
        </div>
        <span className='teamtitle'>
          <span className='title'>{team.name}</span>
        </span>
      </div>
    )
  }
}

export default TeamItem
